import { createApiAction } from '@app/packages/api/utils'
import type { ApiFirebaseToken } from '@app/packages/api/v2/types/entities'

export const postFirebaseFcmSubscribe = (instance_id: string) =>
  createApiAction('postFirebaseFcmSubscribe', dispatch =>
    dispatch<unknown>({ method: 'POST', endpoint: '/api/v2/firebase/fcm/subscribe', body: JSON.stringify({ instance_id }) })
  )

export const postFirebaseTokens = () =>
  createApiAction('postFirebaseTokens', dispatch => dispatch<{ data: ApiFirebaseToken }>({ method: 'POST', endpoint: '/api/v2/firebase/tokens' }))
